module.exports = __webpack_public_path__ + "img/purple-circle-table-4.22749c7c.png";